{
    "exercise_type": {
      "Strength": "Força",
      "Cardio": "Cardio",
      "Mobility": "Mobilidade",
      "default": "Exercício"
    },
    "period": {
      "morning": "Manhã",
      "afternoon": "Tarde",
      "night": "Noite",
      "default": "Morning"
    },
    "week_day_short": {
      "Monday": "Segunda",
      "Tuesday": "Terça",
      "Wednesday": "Quarta",
      "Thursday": "Quinta",
      "Friday": "Sexta",
      "Saturday": "Sábado",
      "Sunday": "Domingo",
      "default": "Segunda"
    },
    "today": "Hoje",
    "stay": {
      "station": "FICA NA ESTAÇÃO",
      "pod": "CONTINUA NESTE POD",
      "station_move": "TROCA DE ESTAÇÃO",
      "pod_move": "TROCA DE POD",
      "set_station": "Após este Set, fica na Estação",
      "set_station_move": "Após este Set, troca de Estação",
      "set_pod_move": "Após este Set, troca de Pod",
      "get_ready": "Prepara-te",
      "introduction": "Introdução"
    },

      "sets_number_one": "Ainda falta {{count}} set",
      "sets_number_other": "Ainda faltam {{count}} sets",

    "stations": "Estações",
    "sets": "Sets",
    "exercise": "Exercício",
    "work": "Exercício",
    "warmup":"Aquecimento",
    "hydration": "Intervalo",
    "rest": "Descanso",
    "pods": "Pods",
    "total_time": "Tempo Total",
    "laps": "Voltas",
    "finish": {
      "finish": "BOM TRABALHO"
    },
    "hydrate": {
      "recover": "DESCANSAR"
    },
    "next_class": "Próxima aula"
  }